// Guard для auth-форм (/signup, /signin, /forgot-password): если пользователь
// уже залогинен, ведём по onboarding-state вместо рендера формы.
// Source of truth: docs/specs/sprint-3/stage-1-contracts.md §6.2.
//
// Stage 4 amend: Stage 1 §6.2 объявлял RequireUnauth как один из трёх guard'ов,
// но stage-4-screens.md §3 явно описал только Auth/Consent/OnboardingRouter.
// v0.93.1 review fix добавляет RequireUnauth обратно — без него залогиненный
// юзер мог зайти на /signup и зарегистрировать ещё один аккаунт.

import { Redirect } from 'wouter';
import type { ReactNode } from 'react';
import { useOnboardingState } from '@/hooks/useOnboardingState';
import { pathForState } from './OnboardingRouter';
import { FullScreenSpinner } from '@/components/FullScreenSpinner';

export function RequireUnauth({ children }: { children: ReactNode }) {
  const { state, isLoading } = useOnboardingState();
  if (isLoading) return <FullScreenSpinner />;
  if (state && state.kind !== 'unauth') {
    return <Redirect to={pathForState(state)} />;
  }
  return <>{children}</>;
}
